import React, { useState, useEffect } from "react";
import behandelingenData from "../data/behandelingen.json";

const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    setServices(behandelingenData);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  const slideLeft = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const slideRight = () => {
    if (currentIndex < services.length - Math.floor(100 / 270)) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div className="services-container">
      <div className="header-section">
        <h2>Behandelingen</h2>
        <div className="arrows">
          <img
            src="/images/icon_left_arrow.svg"
            alt="Arrow left"
            className={`arrow-left ${currentIndex === 0 ? "disabled" : ""}`}
            onClick={slideLeft}
            style={{
              opacity: currentIndex === 0 ? 0.5 : 1,
              cursor: currentIndex === 0 ? "default" : "pointer"
            }}
          />
          <img
            src="/images/icon_right_arrow.svg"
            alt="Arrow right"
            className={`arrow-right ${
              currentIndex === services.length - 1 ? "disabled" : ""
            }`}
            onClick={slideRight}
            style={{
              opacity: currentIndex === services.length - 1 ? 0.5 : 1,
              cursor:
                currentIndex === services.length - 1 ? "default" : "pointer"
            }}
          />
        </div>
      </div>

      <div className="slider">
        <div
          className="slider-cards"
          style={{
            transform: `translateX(-${currentIndex * 7}%)`,
            transition: "transform 0.3s ease-out"
          }}
        >
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-info">
                <div className="img-container">
                  <p className="categorie">{service.categorie}</p>
                  {/* <img src={service.image} alt={service.title} /> */}
                </div>

                <a href={`/behandelingen/${service.id}`}>
                  <h3>{service.title}</h3>
                </a>
                <div className="cat-footer">
                  <p>
                    {service.vanaf} {service.price_1}
                  </p>
                  <a href={`/behandelingen/${service.id}`}>
                    <img src="/images/icon_next.svg" alt="Icon Next" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
